
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 728 150"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M677.7 75c0 18.6-11 30.8-27.5 30.8S622.8 93.6 622.8 75s11-30.8 27.5-30.8 27.4 12.2 27.4 30.8M721 41.1l3.7-25.8c.4-2-.9-4-2.9-4.5-.5-.1-.9-.1-1.4 0l-23.2 2.3C684.7 4.7 668.7 0 650.2 0c-46.7 0-77.7 30-77.7 75s31 75 77.7 75S728 120 728 75c.1-11.7-2.3-23.2-7-33.9M474.5 100.8V49.6c0-4.2 3.2-5.3 5.1-5.4H487.4c16.3 0 27 11.4 27 30.9s-10.8 30.8-27.2 30.8h-7.6c-2.8 0-5-2.2-5-5M564.7 75c0-47.1-30.8-75-81.8-75-17.7 0-26.2.3-41.9.9-6.6.2-10.9.4-10.9.4-2.8.1-5 2.4-5 5.3v133.3c0 5.1.6 8.3 7.6 8.6 9.4.4 16.5.6 23.2.8h.3l1.8.1H467.5l1.4-.2H485c48.8.3 79.7-27.1 79.7-74.2zM302.7 144.4c0 2.8 2.2 5 5 5.1H410c2.8 0 5-2.3 5-5.1v-34.8c0-2.8-2.3-5-5-5h-52.9c-2.7 0-5-2.3-5-5V5.1c0-2.8-2.2-5-5-5.1h-39.4c-2.8 0-5 2.3-5 5.1v139.3zM219.9 91.7h-15.5c-1.8.2-3.5-1.2-3.7-3-.1-.6 0-1.2.3-1.7l9.6-27.2c.9-2.6 2.4-2.6 3.3 0l9.4 27.2c.8 1.7 0 3.7-1.6 4.5-.6.1-1.2.3-1.8.2m74.1 52.9L236.6 5c-1.3-2.7-4-4.5-7-4.7h-35.8c-3 .2-5.7 1.9-7 4.7l-56.5 139.6c-1.1 2.6.3 4.6 3.1 4.6h41.2c3-.1 5.6-2 6.7-4.8l2.2-8.7c1.1-2.8 3.7-4.6 6.7-4.8H234c3 .1 5.6 2 6.7 4.8l2.2 8.7c1.1 2.8 3.7 4.6 6.7 4.8h41.2c2.9 0 4.2-2 3.2-4.6M59.7 46.9c0-4.4 4.2-5.7 11.4-5.7 12.2 0 47.5 8.9 47.5 8.9 2.5.7 5.1-.9 5.8-3.4 0-.1.1-.2.1-.3 0 0 5.6-28 6.4-32.1s-2.3-5.5-3.9-5.9C108 3.4 88.5.7 68.8.5c-40.8 0-64 17.1-64 49.4 0 26.6 15.8 36.3 49.4 44.1 13.3 3.2 22.2 4.2 22.2 9.3 0 1.9-1.3 6.6-12.9 5.9-10.3-.6-49-11.5-49-11.5-2.7-.7-5.4.8-6.2 3.5 0 0-7 26.2-8.1 30.4s1.5 6 2.9 6.4c22.7 6.8 45.7 12 67.4 12 40.1 0 62.5-18.2 62.5-47.3 0-30.6-24.3-40.1-49.9-46.3-15.7-3.8-23.3-3.8-23.4-9.5"}})])
          )
        }
      }
    